import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GetNewslettersResponse } from '../data-access/models/newsletters-api.model';
import { NewslettersApi } from '../data-access/services/newsletters-api';

export const newslettersResolver: ResolveFn<GetNewslettersResponse> = () => inject(NewslettersApi).getNewsletters$();
